/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-multimedia-display.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/shared/pipe/safe-url.pipe';
import * as i4 from '@angular/platform-browser';
import * as i5 from '../../../../../app/shared/component/tx-multimedia-display/tx-multimedia-display.component';
const styles_TxMultimediaDisplayComponent:any[] = [i0.styles];
export const RenderType_TxMultimediaDisplayComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxMultimediaDisplayComponent,data:{}});
function View_TxMultimediaDisplayComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'img',[['alt',
      '']],[[8,'src',4]],(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.file.url || _co.file.path);
        _ck(_v,0,0,currVal_0);
      });
}
function View_TxMultimediaDisplayComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'video',[['controls',
      'controls'],['preload','metadata']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'source',[['alt',''],['type',
          'video/mp4']],[[8,'src',4]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',(_co.file.url || _co.file.path),
        '#t=0.5');
    _ck(_v,2,0,currVal_0);
  });
}
function View_TxMultimediaDisplayComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),18,'div',[['class',
      'file']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TxMultimediaDisplayComponent_2)),i1.ɵdid(3,
          16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_3)),
      i1.ɵdid(6,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(8,0,(null as any),(null as any),0,'div',[['class','overlay']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),7,'div',[['class','button clickable']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵeld(12,0,(null as any),(null as any),1,'a',([] as any[]),
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.removeFileFromList()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[' REMOVER '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(15,0,(null as any),
          (null as any),1,'a',([] as any[]),(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.openFile()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[' ABRIR '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.isImage();
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.isVideo();
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
function View_TxMultimediaDisplayComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'a',[['target',
      '_blank']],[[1,'href',4]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'img',([] as any[]),[[1,'src',4]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.file.url || _co.file.path);
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = _co.file.path;
        _ck(_v,2,0,currVal_1);
      });
}
function View_TxMultimediaDisplayComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'video',[['controls',
      'controls'],['preload','metadata']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'source',[['alt',''],['type',
          'video/mp4']],[[8,'src',4]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',(_co.file.url || _co.file.path),
        '#t=0.5');
    _ck(_v,2,0,currVal_0);
  });
}
function View_TxMultimediaDisplayComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'file']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.openFile()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_5)),
      i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_6)),
      i1.ɵdid(6,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.file.fileType === 'IMAGE');
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = (_co.file.fileType === 'VIDEO');
        _ck(_v,6,0,currVal_1);
      },(null as any));
}
function View_TxMultimediaDisplayComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'div',[['class',
      'overlay']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_TxMultimediaDisplayComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'button clickable']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.removeFileFromList()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[' REMOVER '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(5,0,(null as any),
          (null as any),1,'a',([] as any[]),(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.openFile()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[' ABRIR '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(null as any));
}
function View_TxMultimediaDisplayComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),10,'div',[['class',
      'file']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'embed',[['type','application/pdf']],[[8,'src',5]],(null as any),
          (null as any),(null as any),(null as any))),i1.ɵppd(3,1),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_TxMultimediaDisplayComponent_8)),i1.ɵdid(6,16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TxMultimediaDisplayComponent_9)),i1.ɵdid(9,
          16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.removeIsEnabled;
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = _co.removeIsEnabled;
    _ck(_v,9,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵunv(_v,2,0,_ck(_v,3,0,i1.ɵnov((<any>_v.parent),0),(_co.file.path || _co.file.url)));
    _ck(_v,2,0,currVal_0);
  });
}
function View_TxMultimediaDisplayComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'file']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.openFile()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),1,'embed',[['type','application/pdf']],
          [[8,'src',5]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.openFile()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵppd(3,1),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵunv(_v,2,0,_ck(_v,3,0,i1.ɵnov((<any>_v.parent),0),(_co.file.path || _co.file.url)));
    _ck(_v,2,0,currVal_0);
  });
}
export function View_TxMultimediaDisplayComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i3.SafeUrlPipe,[i4.DomSanitizer]),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_1)),
      i1.ɵdid(2,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_4)),
      i1.ɵdid(5,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_7)),
      i1.ɵdid(8,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxMultimediaDisplayComponent_10)),
      i1.ɵdid(11,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i5.TxMultimediaDisplayComponent = _v.component;
        const currVal_0:any = (_co.removeIsEnabled && !_co.notVideoOrImage);
        _ck(_v,2,0,currVal_0);
        const currVal_1:boolean = (!_co.removeIsEnabled && !_co.notVideoOrImage);
        _ck(_v,5,0,currVal_1);
        const currVal_2:any = (_co.removeIsEnabled && _co.notVideoOrImage);
        _ck(_v,8,0,currVal_2);
        const currVal_3:boolean = (!_co.removeIsEnabled && _co.notVideoOrImage);
        _ck(_v,11,0,currVal_3);
      },(null as any));
}
export function View_TxMultimediaDisplayComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-multimedia-display',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxMultimediaDisplayComponent_0,
      RenderType_TxMultimediaDisplayComponent)),i1.ɵdid(1,114688,(null as any),0,i5.TxMultimediaDisplayComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxMultimediaDisplayComponentNgFactory:i1.ComponentFactory<i5.TxMultimediaDisplayComponent> = i1.ɵccf('tx-multimedia-display',
    i5.TxMultimediaDisplayComponent,View_TxMultimediaDisplayComponent_Host_0,{removeIsEnabled:'removeIsEnabled',
        file:'file'},{txOnRemoveFileFromList:'txOnRemoveFileFromList'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-multimedia-display/tx-multimedia-display.component.ngfactory.ts